import { render, staticRenderFns } from "./ManagePayBoxCommandsSidebar.vue?vue&type=template&id=ba7e205c&"
import script from "./ManagePayBoxCommandsSidebar.vue?vue&type=script&lang=js&"
export * from "./ManagePayBoxCommandsSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba7e205c')) {
      api.createRecord('ba7e205c', component.options)
    } else {
      api.reload('ba7e205c', component.options)
    }
    module.hot.accept("./ManagePayBoxCommandsSidebar.vue?vue&type=template&id=ba7e205c&", function () {
      api.rerender('ba7e205c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/manage-pay-box-commands/ManagePayBoxCommandsSidebar.vue"
export default component.exports